import React from "react";

interface HtmlElementProps {
  element: Element;
}

export const HtmlElement = ({ element }: HtmlElementProps) => element;
